import React from 'react';

export const Card = ({ title, icon, children }) => (
  <div className="bg-white p-6 rounded-lg shadow-sm border">
    <div className="flex items-center space-x-3 mb-3">
      <div className="p-2 bg-blue-50 rounded-lg">{icon}</div>
      <h3 className="font-semibold text-gray-900">{title}</h3>
    </div>
    <div className="text-sm text-gray-600">{children}</div>
  </div>
);

export const FeatureCard = ({ icon, iconBg = 'bg-blue-100', title, description }) => (
  <div className="bg-white p-6 rounded-lg shadow-sm border">
    <div className="flex items-center space-x-3 mb-4">
      <div className={`p-2 ${iconBg} rounded-lg`}>{icon}</div>
      <h3 className="font-semibold text-gray-900">{title}</h3>
    </div>
    <p className="text-gray-600 text-sm">{description}</p>
  </div>
);

export const Step = ({ number, title, children }) => (
  <div className="flex items-start space-x-3">
    <div className="flex-shrink-0 w-8 h-8 bg-blue-100 rounded-full flex items-center justify-center">
      <span className="text-sm font-medium text-blue-600">{number}</span>
    </div>
    <div>
      <h4 className="font-medium text-gray-900">{title}</h4>
      <p className="text-sm text-gray-600 mt-1">{children}</p>
    </div>
  </div>
);

export const FaqItem = ({ question, children }) => (
  <div>
    <h4 className="font-semibold text-gray-900">{question}</h4>
    <p className="mt-1 text-sm text-gray-700">{children}</p>
  </div>
);

export const Issue = ({ title, color, children }) => (
  <div className={`border-l-4 ${color} pl-4`}>
    <h4 className="font-medium text-gray-900">{title}</h4>
    <p className="text-sm text-gray-600 mt-1">{children}</p>
  </div>
);

export const WelcomeHero = ({ icon, title, description, cards }) => (
  <div className="bg-gradient-to-r from-blue-50 to-blue-50 p-6 rounded-lg border border-blue-200">
    <div className="flex items-start space-x-4">
      <div className="p-2 bg-blue-100 rounded-lg">{icon}</div>
      <div className="flex-1">
        <h3 className="text-xl font-semibold text-gray-900 mb-3">{title}</h3>
        <p className="text-gray-700 mb-4">{description}</p>
        {cards?.length > 0 && (
          <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
            {cards.map((card) => (
              <div key={card.title} className="bg-white p-4 rounded-lg">
                <div className="flex items-center space-x-2 mb-2">
                  {card.icon}
                  <span className="font-medium text-gray-900">{card.title}</span>
                </div>
                <p className="text-sm text-gray-600">{card.description}</p>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  </div>
);

export const QuickStartPanel = ({ title, icon: Icon, children }) => (
  <div className="bg-white p-6 rounded-lg shadow-sm border">
    <h3 className="text-lg font-semibold text-gray-900 mb-4 flex items-center">
      {Icon ? <Icon className="w-5 h-5 mr-2" /> : null}
      {title}
    </h3>
    <div className="space-y-4">{children}</div>
  </div>
);

export const SectionPanel = ({ title, icon: Icon, children }) => (
  <div className="bg-white p-6 rounded-lg shadow-sm border">
    <h3 className="text-lg font-semibold text-gray-900 mb-4 flex items-center">
      {Icon ? <Icon className="w-5 h-5 mr-2" /> : null}
      {title}
    </h3>
    {children}
  </div>
);

export const AnalyticsLinkButton = ({ href = '/analytics', label = 'Go to Analytics' }) => (
  <div className="mt-6">
    <button
      type="button"
      onClick={() => { window.location.href = href; }}
      className="inline-flex items-center px-4 py-2 rounded-md bg-blue-600 text-white text-sm font-medium hover:bg-blue-700"
    >
      {label}
    </button>
  </div>
);
